module.exports = __webpack_public_path__ + "static/media/ico-footer-3.1582a3d6.svg";